// export { default } from './base/sample/sample';

import * as Navigation from './03-page-components/navigation/navigation';
import * as TogglePageHeaderSearch from './04-content-components/pageheader/page-header/page-header';
import * as StartHeader from './04-content-components/start-header/start-header';
import * as TextmediaLightboxImage from './04-content-components/textmedia/textmedia';
import * as MediaPlayer from './04-content-components/media/media';
// import * as Jumpmarks from './04-content-components/jumpmarks/jumpmarks';
import * as Accordion from './04-content-components/accordion/accordion';
import * as LinkCarousel from './04-content-components/teaser/link-carousel/link-carousel';
import * as ImageGallery from './04-content-components/image-gallery/image-gallery';
import * as RelatedContent from './04-content-components/related-content/related-content';
import * as openCloseText from './05-micro-components/introtext/introtext';
import * as Blogs from './04-content-components/blogs/blogs';
import * as Downloads from './04-content-components/downloads/downloads';
import * as Facts from './04-content-components/facts/facts';
import * as Centers from './04-content-components/center/centers/centers';
import * as Testimonials from './04-content-components/testimonials/testimonials';
import * as Contacts from './04-content-components/contact/contact';
import * as Podcasts from './04-content-components/podcasts/podcasts';
import * as VideoSlider from './04-content-components/video-slider/video-slider';
import * as HighlightTeaser from './04-content-components/teaser/highlight-teaser/highlight-teaser';
import * as TabTeaser from './04-content-components/teaser/tab-teaser/tab-teaser';
import * as ListTeaser from './04-content-components/teaser/list-teaser/list-teaser';
import * as NewsTeaser from './04-content-components/teaser/news-teaser/news-teaser';
import * as RelatedLinks from './05-micro-components/related-links/related-links';
import * as Comments from './04-content-components/comments/comments';
import * as Form from './04-content-components/form/form';
import * as Share from './05-micro-components/share/share';
import * as PortraitSlider from './04-content-components/portrait-slider/portrait-slider';
import * as Search from './04-content-components/search/search';
import * as CookieBanner from './03-page-components/cookie-banner/cookiebanner';
import * as LivestreamHeader from './04-content-components/pageheader/livestream-header/livestream-header';
import * as Map from './04-content-components/map/map';
import * as HubEventTeaser from './04-content-components/teaser/hub-event-teaser/hub-event-teaser';
import * as EventTeaser from './04-content-components/teaser/event-teaser/event-teaser';
import * as Story from './04-content-components/story/story';
import * as BannerTeaserVideo from './04-content-components/banner/banner-teaser/banner-teaser';
import * as TeaserAwards from './04-content-components/teaser/teaser-awards/teaser-awards';
import * as TeaserImageGrid from './04-content-components/teaser/teaser-image-grid/teaser-image-grid';

export {
  Navigation,
  TogglePageHeaderSearch,
  StartHeader,
  TextmediaLightboxImage,
  MediaPlayer,
  // Jumpmarks,
  Accordion,
  LinkCarousel,
  ImageGallery,
  RelatedContent,
  openCloseText,
  Blogs,
  Downloads,
  Facts,
  Centers,
  Testimonials,
  Contacts,
  Podcasts,
  VideoSlider,
  HighlightTeaser,
  TabTeaser,
  ListTeaser,
  NewsTeaser,
  RelatedLinks,
  Comments,
  Form,
  Share,
  PortraitSlider,
  Search,
  CookieBanner,
  LivestreamHeader,
  Map,
  HubEventTeaser,
  EventTeaser,
  Story,
  BannerTeaserVideo,
  TeaserAwards,
  TeaserImageGrid,
};

document.addEventListener(
  'focusin',
  function () {
    console.log('focused: ', document.activeElement);
  },
  true
);
